
import dateFormat from 'vux/src/tools/date/format.js'

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
name: 'DeliveImgList',
components: {
MyBtnReturn
},
data() {
return {

src2: require('@/assets/images/wx_song_green.png'), // 送货的icon图片
tableData: [],
isShowTable: true,
isShowLoading: false,
isNoData: false,
}
},
created() {
document.title = '送货图片';
this.getData()
},
methods: {
getData() {
let data = {
openId: apiParams.openId,
companyId: apiParams.companyId,
code: apiParams.code,
};
this.isShowLoading = true;

this.requestApi({
url: apiUrl.deliveImgListController,
data: data
}, (resultData) => {
let list = resultData.data.list || [];
if (list.length === 0) {

this.isNoData = true;
this.isShowLoading = false;
this.isShowTable = false;
return
}
this.tableData = list;
}, (error) => {
this.isShowLoading = false;
if (error) {
console.error(error); 
}
})
},
goNextPage(bookingId, ladingId, servicetype) {

this.$router.push({
name: 'DeliveImgLading',
query: {
bookingId: bookingId,
ladingId: ladingId,
servicetype: servicetype,
}
})
},
dateFormat(time) {
return dateFormat(time, 'YYYY-MM-DD HH:mm')
}
}
}



// WEBPACK FOOTER //
// ./src/components/siji/deliveImg/DeliveImgList.vue